import createErrorsSchema from './src/createErrorsSchema/create';

/**
 * Se crea en el ecFormBuilderService.Validator
 */
export default class Validator {
  /**
   *
   * @param {Object} param
   * @param {Object} [param.iece] la in4. Opcional, se puede pasar luego en el `validate`
   * @param {Object} [param.view] el view. Opcional, se puede pasar luego en el `validate`
   * @param {Object} [param.data] el objeto de datos. Opcional, se puede pasar luego en el `validate`
   * @param {Object} [param.options] Opcional
   * @param {Object} param.runValidate Es la función que ejecuta la validación, es el `fbErrorsService.validate` workerizado
   */
  constructor({ iece = null, view = null, data = {}, options = {}, runValidate }) {
    if (!iece || !view) {
      throw new Error('ecFormBuilder.Validator: iece y view obligatorios.');
    }

    this.iece = iece;
    this.view = view;
    this.schema = createErrorsSchema(this.iece, this.view);
    this.data = data;
    this.options = options;
    this.runValidate = runValidate;
  }

  /**
   * Ejecuta la validación.
   *
   * @param {Object} param0
   * @returns
   */
  validate({ iece = null, view = null, data = null, options = null }) {
    this.data = data || this.data;
    if (!this.data) {
      throw new Error('ecFormBuilder.Validator.validate: data obligatorio.');
    }
    this.options = options || this.options;

    if ((iece && iece !== this.iece) || (view && view !== this.view)) {
      this.iece = iece || this.iece;
      this.view = view || this.view;
      this.schema = createErrorsSchema(this.iece, this.view);
    }

    return this.runValidate(this.schema, this.data, this.options);
  }
}
